import { useHistory } from "react-router-dom";

import { useFinanceAllProjectList } from "../../api/project";
import { Loader } from "../../common/components/core";
import { BesuProjectState } from "../../types/project";
import { PageTitle } from "../../types/pageTitle";

import ProjectAccountForm from "./components/ProjectAccountForm";
import useUpdateProjectAccountHandler from "./hooks/useUpdateProjectAccountHandler";

const ManageProjectAccountView = (): JSX.Element => {
    document.title = PageTitle.ManageProjectAccountView;
    const history = useHistory();
    const { data: projects, isValidating } = useFinanceAllProjectList();

    return (
        <Loader isLoading={isValidating}>
            {projects && (
                <PureManageProjectAccountView
                    projects={projects.map((it) => it)}
                    onCancel={() => history.push("/collection")}
                />
            )}
        </Loader>
    );
};

type PureManageProjectAccountViewProps = {
    projects: BesuProjectState[];
    onCancel: () => void;
};

export const PureManageProjectAccountView = ({
    projects,
    onCancel,
}: PureManageProjectAccountViewProps): JSX.Element => {
    const { handler: update } = useUpdateProjectAccountHandler();
    return (
        <ProjectAccountForm
            projects={projects}
            onCancel={onCancel}
            onSubmit={update}
        />
    );
};

export default ManageProjectAccountView;
